import React from "react"
import logo from '../../assets/image/logo.png'

export const Logo = () => {
  return (
    <img style={{width: '250px'}} src={logo} alt=""/>
  )
}
